(function () {
  'use strict';
  var wrapper = document.querySelector('[data-raqa-sticky-atc]');
  if (!wrapper) return;

  var mainAtcSelector = wrapper.dataset.watchSelector || '.raqa-pdp__atc';
  var mainAtc = document.querySelector(mainAtcSelector);
  var footer = document.querySelector(wrapper.dataset.footerSelector || 'footer');
  if (!mainAtc) return;

  var showClass = 'raqa-sticky-atc--visible';
  var mainScrolledPast = false;
  var footerVisible = false;

  function update() {
    if (mainScrolledPast && !footerVisible) {
      wrapper.classList.add(showClass);
    } else {
      wrapper.classList.remove(showClass);
    }
  }

  var ticking = false;
  function checkMainAtc() {
    var rect = mainAtc.getBoundingClientRect();
    mainScrolledPast = rect.bottom < 0;
    update();
    ticking = false;
  }

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(checkMainAtc);
      ticking = true;
    }
  }, { passive: true });
  window.addEventListener('resize', checkMainAtc, { passive: true });
  checkMainAtc();

  if ('IntersectionObserver' in window && footer) {
    var footerObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        footerVisible = entry.isIntersecting;
        update();
      });
    }, { threshold: 0 });
    footerObserver.observe(footer);
  }
})();
